/** Shared constants and helpers for the card-payment-sca flow. */

/** Matches the folder name and the host's `init.flowId` (PRD § 11 O-1). */
export const FLOW_ID = 'card-payment-sca';

/**
 * Absolute in-flow path. The app's `BrowserRouter` has `basename="/flows"`, so
 * `/card-payment-sca/<sub>` resolves to `/flows/card-payment-sca/<sub>`. Using
 * absolute paths (anchored at the flow id) avoids the relative-segment counting
 * fragility of the nested-routes splat — see forms-host wizard routing notes.
 */
export const flowPath = (sub: string): string => `/${FLOW_ID}/${sub}`;

/** Locale-correct money formatting (2 decimals); the currency goes to DataAmount. */
export const formatAmount = (amountNum: number, locale: string): string => {
  if (Number.isNaN(amountNum)) return '';
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amountNum);
};
